// Indicator catalog client. Hit once at startup; cache via useIndicatorCatalog.

import { fetchJson, URLS } from "./client";

export interface IndicatorParamDescriptor {
  key: string;
  label: string;
  description: string | null;
  min: number;
  max: number;
  step: number;
  default: number;
}

export interface IndicatorCatalogEntry {
  baseId: string;
  displayName: string;
  group: string;
  description: string;
  paramDescriptors: IndicatorParamDescriptor[];
}

export function fetchIndicatorCatalog(signal?: AbortSignal): Promise<IndicatorCatalogEntry[]> {
  return fetchJson<IndicatorCatalogEntry[]>(`${URLS.historicalIndicators}/Indicators`, { signal });
}
